import { createSelector } from 'reselect';
import formatPosition from '../../helpers/positionFormatter';
import { positionSelector } from './positionSelectors';
var productsSelector = function productsSelector(state) {
  return state.apexCore.product.products;
};
var assetsSelector = function assetsSelector(state) {
  return state.productManifest.manifest;
};
export var fetchingSelector = createSelector([function (state) {
  return state.apexCore.product;
}, function (state) {
  return state.apexCore.position;
}, function (state) {
  return state.productManifest;
}], function (product, position, manifest) {
  return product.fetching || position.fetching || manifest.fetching;
});
export var productPositionSelector = createSelector([productsSelector, function (state) {
  return state.apexCore.product.decimalPlaces;
}, positionSelector], function (products, decimalPlaces, positions) {
  return products.map(function (product) {
    var position = positions[product.ProductId];
    if (!position) {
      return product;
    }
    var positionDecimals = decimalPlaces[product.Product];
    var formattedPosition = formatPosition(position, positionDecimals);
    return Object.assign({}, formattedPosition, product);
  });
});
export var productPositionAssetsSelector = createSelector([productPositionSelector, assetsSelector], function (products, assets) {
  return products.map(function (product) {
    var asset = assets[product.Product] || {
      iconFileName: product.Product + 'DEFAULT_ICON'
    };
    return Object.assign({}, product, asset);
  });
});
export var getProductByIdSelector = createSelector([productPositionAssetsSelector, function (state, productId) {
  return productId;
}], function (products, productId) {
  return products.find(function (item) {
    return item.ProductId === productId;
  });
});
export var fundedPositionsSelector = createSelector(productPositionAssetsSelector, function (positions) {
  // productPositionsSelector replaces Amount 0 with '-'
  return positions.filter(function (position) {
    return position.Amount !== '-';
  });
});
export var unfundedPositionsSelector = createSelector(productPositionAssetsSelector, function (positions) {
  // productPositionsSelector replaces Amount 0 with '-'
  return positions.filter(function (position) {
    return position.Amount === '-';
  });
});